
import { defineComponent } from 'vue';

export default defineComponent({
  data () {
    return {
      user: {
        firstName: 't',
        lastName: 'k'
      }
    }
  }
})
